export const cmOpen = (...payload) => {
    document.querySelector('#app').__vue__.$refs.menu.open(...payload)
}